<ng-template #content_login let-offcanvas>
  <div class="{{localService.selectedLanguageCode}}"
    *ngIf="!localService.viewAsReturnCountryCodeUserId && localService.languageContent && localService.languageContent.login">
    <div *ngIf="localService.lastUsedSettings && !isPopupOpened">
      <div class="side_popup_header">
        <span>{{localService.languageContent.login.login_request}}</span>
        <button class="button_icon" (click)="onCloseTrigger()">close</button>
      </div>
      <div class="side_popup_body" [ngStyle]="{'max-height' : (localService.sideBarBodyHeight + 50) + 'px'}">
        <div class="row">
          <div class="col-md-12">
            <div class="center">
              <app-country-contact *ngIf="!isVerificationPart" [countryId]="selectedCountryId"
                [phoneNumber]="phoneNumber" (onContactUpdated)="onContactUpdated($event)"
                (onEnterPressed)="localService.onFocusNextInput(elementIds.pwd,1)"></app-country-contact>
              <div *ngIf="message != ''" style="text-align:center;">
                <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'yellowgreen' }">{{message}}</span>
              </div>
              <div *ngIf="!isVerificationPart">
                <form>
                  <input autocomplete="off" id="{{elementIds.pwd}}" type="{{isShowPassword ? 'text' : 'password'}}"
                    [ngClass]="isShowPassword ? 'en' : (txtPassword == '' ? '' : 'ta')" [(ngModel)]="txtPassword"
                    placeholder="*{{localService.languageContent.login.login_placeholder_password}}"
                    title="*{{localService.languageContent.login.login_placeholder_password}}"
                    (keydown.enter)="onLogin()" style="width: calc(100% - 40px);"
                    [ngModelOptions]="{standalone: true}" />
                  <button class="button_icon" style="top:5px;"
                    [ngStyle]="{'color': isShowPassword ? 'orangered' : 'yellowgreen' }"
                    (click)="onShowHidePassword()">visibility</button>
                </form>
              </div>
              <div *ngIf="!isVerificationPart">
                <div *ngIf="!localService.isHideDummy">
                  <label style="font-weight: normal; margin-left: 15px;">
                    <input type="checkbox" [(ngModel)]="localService.isEnableAutoLoginNextTime" (change)="onFocus()" />
                    <span class="normal_color">{{localService.languageContent.login.enable_auto_login}}</span>
                  </label>
                </div>
                <div class="row" style="margin-top: 10px;">
                  <div class="col-6">
                    <span *ngIf="isShowPassword" class="show_pwd_seconds en">{{showPasswordDisappearSeconds}}</span>
                  </div>
                  <div class="col-6">
                    <button id="{{elementIds.login}}" (click)="onLogin()" type="button" class="btn btn-primary"
                      style="float:right">{{localService.languageContent.login.login}}</button>
                  </div>
                </div>
              </div>
              <app-otp-container *ngIf="isVerificationPart" [PhNumOrEmail]="phoneNumber" [otpType]="4"
                (onPasswordChanged)="onPwdChanged($event)" (onNotAllowed)="onNotAllowed()" (onBlocked)="onBlocked()"
                (onNew)="onNew()"></app-otp-container>
              <div style="text-align:justify;" *ngIf="!isVerificationPart">
                <br />
                <div class="side_popup_body_row_group">
                  <div class="side_popup_body_row">
                    <span class="button"
                      (click)="onForgotPwd()">{{localService.languageContent.login.forgot_password}}</span>
                  </div>
                  <br />
                  <div class="side_popup_body_row">
                    <span>{{localService.languageContent.login.dont_have_account}}&nbsp;</span>
                    <span class="button"
                      (click)="onCreateAccountClick()">{{localService.languageContent.login.start_from_here}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<div>
  <app-create-account *ngIf="selectedContact" [(isOpenPopup)]="isOpenCreateAccount" [ctryCode]="selectedContact.v2"
    [PhoneNumber]="phoneNumber" (onClose)="onCloseCreateAccount($event)"></app-create-account>
</div>